<div class="upp-konva" data-id="upp-konva-integration">
  <upp-konva-floor-plan
    class="upp-konva__stage-host"
    [model]="model.sceneModel"
    [active]="active"
    [theme]="theme"
    (onChange)="onStageAreaChange($event)"
    (onSelect)="onFloorPlanSelect($event)"
    (onTransform)="onTransform.emit($event)"
  />
</div>
